<template>
  <v-container :fluid="true" class="page_container pt-0">
    <v-row no-gutters>
      <v-col cols="12" lg="6" class="main--left">
        <div class="main__content">
          <div class="icon__hide_open" @click="show_info = !show_info">
            <v-icon size="30" color="#3254B9" v-if="!show_info">visibility</v-icon>
            <v-icon size="30" color="#3254B9" v-else>visibility_off</v-icon>
          </div>
          <div v-if="!isLoadingMembers && member">
            <div class="main__user_fio">
              <p>{{ member.last_name }}</p>
              <p>{{ member.name }}</p>
              <p>{{ member.middle_name }}</p>
            </div>
            <div class="main__user_birth">
              <p :class="{ 'text__blur': !show_info }">{{ calculateAge(member.birth) }} ( {{ displayDate(member.birth) }})</p>
            </div>
            <div class="main__user_status">
              <span class="main__user_status--chip">{{ checkType(member.member_request.type) }}</span>
            </div>
            <div class="main__user_data" v-for="(item, index) in member_fields[member.member_request.type]" :key="`${index}_info`">
              <div class="main__user_data--name">{{ item.name }}:</div>
              <div class="main__user_data--text" v-if="item.member_request">
                <span :class="{ 'text__blur': !show_info }">{{ member[item.field][item.member_request] }}</span>
              </div>
              <div class="main__user_data--text" v-if="item.member_request === null">
                <span :class="{ 'text__blur': !show_info }" v-if="member[item.field] !== ''">{{ member[item.field] }}</span>
                <span :class="{ 'text__blur': !show_info }" v-else><v-icon size="17">minimize</v-icon></span>
                <v-tooltip location="bottom" v-if="item.name === 'электронная почта' && this.getUserStatus.resending">
                  <template v-slot:activator="{ props }">
                    <v-chip class="ml-3" v-bind="props" @click="resendMailingRequest()">
                      <v-icon size="18" color="#313743">outgoing_mail</v-icon>
                    </v-chip>
                  </template>
                  Повторно отправить письмо для подтверждения смены почты
                </v-tooltip>
              </div>
            </div>
          </div>
          <div v-else-if="!isLoadingMembers && member === null">
            <NoData/>
          </div>
          <div v-else>
            <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
              <fulfilling-square-spinner
                  :animation-duration="4000"
                  :size="100"
                  color="#34347C"
              />
            </v-row>
          </div>
          <div
              class="edit__member"
              @click="clickChangeDataDialog"
          >
            изменить личные данные
          </div>
        </div>
      </v-col>
      <v-col cols="12" lg="6" class="main--right">
        <div class="main__content">
          <div v-if="!isLoadingMembers && !!member">
            <UserCard
                :card="member.card ? member.card : null"
            />
          </div>
          <div v-else-if="!isLoadingMembers && member === null">
            <NoData/>
          </div>
          <div v-else>
            <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
              <fulfilling-square-spinner
                  :animation-duration="4000"
                  :size="100"
                  color="#34347C"
              />
            </v-row>
          </div>
        </div>
        <div class="main__content" :style="$vuetify.display.width > 768 ? 'margin-top: 50px' : 'margin-top: 25px'" style="padding: 20px">
          <div v-if="!isLoadingMembers && !!member" class="main__user_id">
            <p>Mendeleev-ID</p>
            <v-btn
                @click="copyInClipboard(member.card.number+'@mail.mendeleevskayakarta.ru')"
                :color="copy ? '#ffffff' : '#376FFE'"
                width="110"
                height="25"
                elevation="0"
                :class="copy ? 'main__user_id_btn copy' : 'main__user_id_btn'"
            >
              <span v-if="copy">Скопировано</span>
              <span v-else>Скопировать</span>
            </v-btn>
          </div>
          <div v-else-if="!isLoadingMembers && member === null">
            <NoData/>
          </div>
          <div v-else>
            <v-row no-gutters justify="center" align="center" style="min-height: 100px">
              <fulfilling-square-spinner
                  :animation-duration="4000"
                  :size="60"
                  color="#34347C"
              />
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
    <user-change-data-dialog
        :member="member"
        v-model="change_data_dialog"
        v-if="change_data_dialog"
        @save="acceptChangeDataDialog"
        @close="change_data_dialog = false"
    />
    <error-dialog
        v-model="error_dialog"
        v-if="error_dialog"
        :error-text="error_text"
        @close="error_dialog = false"
    />
  </v-container>
</template>

<script>
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import { displayDate } from "@/helper"
import NoData from "@/modules/templates/NoData.vue"
import UserCard from "@/modules/personal_account/users/components/UserCard.vue"
import UserChangeDataDialog from "@/modules/personal_account/users/modals/UserChangeDataDialog.vue"
import ErrorDialog from "@/modules/templates/ErrorDialog.vue"

export default {
  name: "UserInfo",
  components: { ErrorDialog, UserChangeDataDialog, UserCard, NoData, FulfillingSquareSpinner },
  data () {
    return {
      change_data_dialog: false,
      error_dialog: false,
      error_text: 'Произошла непредвиденная ошибка',
      show_info: false,
      copy: false,
      member_fields: {
        schoolchild: [
          { name: 'электронная почта', field: 'email', member_request: null },
          { name: 'Телефон', field: 'phone', member_request: null },
          { name: 'Регион', field: 'region', member_request: 'name' },
          { name: 'Населенный пункт', field: 'city', member_request: null },
          { name: 'образовательная организация', field: 'member_request', member_request: 'organization' },
          { name: 'класс', field: 'member_request', member_request: 'class_name' },
        ],
        student: [
          { name: 'электронная почта', field: 'email', member_request: null },
          { name: 'Телефон', field: 'phone', member_request: null },
          { name: 'Регион', field: 'region', member_request: 'name' },
          { name: 'Населенный пункт', field: 'city', member_request: null },
          { name: 'образовательная организация', field: 'member_request', member_request: 'organization' },
          { name: 'Уровень подготовки', field: 'member_request', member_request: 'education_level' },
          { name: 'Курс', field: 'member_request', member_request: 'course' }
        ],
        postgraduate: [
          { name: 'электронная почта', field: 'email', member_request: null },
          { name: 'Телефон', field: 'phone', member_request: null },
          { name: 'Регион', field: 'region', member_request: 'name' },
          { name: 'Населенный пункт', field: 'city', member_request: null },
          { name: 'образовательная организация', field: 'member_request', member_request: 'study_place' },
          { name: 'Курс', field: 'member_request', member_request: 'course' }
        ],
        science: [
          { name: 'электронная почта', field: 'email', member_request: null },
          { name: 'Телефон', field: 'phone', member_request: null },
          { name: 'Регион', field: 'region', member_request: 'name' },
          { name: 'Населенный пункт', field: 'city', member_request: null },
          { name: 'МЕСТО РАБОТЫ', field: 'member_request', member_request: 'work' },
          { name: 'Должность', field: 'member_request', member_request: 'position' },
          { name: 'Ученая степень', field: 'member_request', member_request: 'academic_degree' }
        ]
      }
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      member: 'personal_account/members/getMembers',
      isLoadingMembers: 'personal_account/members/isLoadingMembers',
      getUserStatus: 'auth/getUserStatus'
    }),
  },
  methods: {
    displayDate: displayDate,
    ...mapActions({
      loadMembers: 'personal_account/members/loadMembers',
      resendMailings: 'personal_account/members/resendMailings',
    }),
    ...mapMutations({
      SET_MEMBERS: 'personal_account/members/SET_MEMBERS'
    }),
    // getFileLink (url) {
    //   return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    // },
    copyInClipboard (item) {
      try {
        navigator.clipboard.writeText(item)
        this.copy = true
        setTimeout(() => {
          this.copy = false
        }, "2000")
      } catch (e) {
        console.log(e)
      }
    },
    calculateAge (birth) {
      const currentDate = new Date()
      const birthDate = new Date(birth)
      const birthYear = birthDate.getFullYear()
      const birthMonth = birthDate.getMonth()
      const birthDay = birthDate.getDate()

      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth()
      const currentDay = currentDate.getDate()

      let age = currentYear - birthYear
      // Проверяем, достигли ли уже дня рождения в текущем году
      if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
        age--
      }

      return this.getAgeString(age) // Вызов функции getAgeString и возврат строки
    },
    getAgeString (age) {
      if ((age === 0) || ((age >= 5) && (age <= 20))) {
        return age + ' лет'
      } else if ((age === 1) || (age % 10 === 1)) {
        return age + ' год'
      } else if (((age >= 2) && (age <= 4)) || ((age % 10 >= 2) && (age % 10 <= 4))) {
        return age + ' года'
      } else {
        return age + ' лет'
      }
    },
    acceptChangeDataDialog () {
      this.change_data_dialog = false
      this.loadData()
    },
    clickChangeDataDialog () {
      this.change_data_dialog = true
    },
    loadData (url = undefined) {
      this.loadMembers({
        url: url,
        finalizer: (data) => {
          if (data.member_request.is_two_profiles) {
            data.member_request.education_level = 'Бакалавриат (с двумя профилями)'
          }
          this.SET_MEMBERS(data)
        },
        catcher: () => {}
      })
    },
    resendMailingRequest () {
      this.error_dialog = false
      this.resendMailings({
        finalizer: () => {},
        catcher: (error) => {
          this.error_text = error.error
          this.error_dialog = true
        }
      })
    },
    checkType (value) {
      if (value === "science") {
        return 'Молодой ученый'
      } else if (value === "postgraduate") {
        return 'Аспирант'
      } else if (value === "student") {
        return 'Студент'
      } else if (value === "schoolchild") {
        return 'Школьник'
      } else {
        return 'Отсутствует тип'
      }
    }
  },
  created () {
    this.loadData()
  }
}
</script>

<style scoped lang="scss">
.text__blur {
  color: transparent;
  text-shadow: 0 0 7px rgb(49, 55, 67);
  transition: all .2s;
}

.main {
  &--left {
    padding-right: 25px !important;
  }

  &--right {
    padding-left: 25px !important;
  }
}

.main__content {
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 50px;
  position: relative;
}

.main__user_fio {
  font-weight: 600;
  font-size: 34px;
  line-height: 40px;
  color: #3254B9;
}

.main__user_id {
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  color: #3254B9;
}

.main__user_id_btn {
  margin-top: 10px;
  border-radius: 25px;
  color: white;
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 11px;
  line-height: 15px;

  &.copy {
    color: #376FFE;
    border: 1px solid #376FFE;
  }
}

.main__user_birth {
  padding: 30px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #313743;
}

.main__user_status {
  margin-bottom: 30px;

  &--chip {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #3254B9;
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 190px;
    height: 32px;
    border-radius: 50px;
  }
}

.icon__hide_open {
  position: absolute;
  top: 25px;
  right: 25px;
}

.main__user_data {
  width: 100%;
  border-bottom: 1px solid #D9D9D9;
  text-align: left;
  margin-bottom: 15px;

  &:last-child {
    border-bottom: none;
    margin-bottom: 5px;
  }

  &--name {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #3254B9;
  }

  &--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #313743;
    padding: 14px 0;
  }
}

.edit__member {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  width: 227px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 0 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

@media screen and (max-width: 1279px) {
  .main {
    &--left {
      padding-right: 0 !important;
      margin-bottom: 50px;
    }

    &--right {
      padding-left: 0 !important;
    }
  }
}

@media screen and (max-width: 768px) {
  .main__content {
    padding: 20px 20px 40px;
  }

  .main {
    &--left {
      padding-right: 0 !important;
      margin-bottom: 20px;
    }

    &--right {
      padding-left: 0 !important;
    }
  }
}

@media screen and (max-width: 428px) {
  .icon__hide_open {
    top: 15px;
    right: 20px;
  }

  .main__user_fio {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
  }

  .main__user_id {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
  }

  .main__user_birth {
    padding: 20px 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
  }

  .main__user_status {
    margin-bottom: 20px;

    &--chip {
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      width: 150px;
      height: 28px;
    }
  }

  .main__user_data {
    &--text {
      font-size: 14px;
      line-height: 17px;
      padding: 10px 0;
    }
  }
}
</style>
